import apiClient from '../axios.js';

export const pointsEarningRulesService = {
  /**
   * 取得常態規則
   * @returns {Promise<Object>} 常態規則
   */
  getNormalRule: async () => {
    const response = await apiClient.get('/admin/points/earning-rules/normal');
    return response;
  },

  /**
   * 更新常態規則
   * @param {Object} data - 規則資料
   * @param {Object} data.tierConfig - 會員等級回饋率設定
   * @param {string} data.calculationBase - 計算基準
   * @param {string} data.roundingMethod - 四捨五入方式
   * @param {number} data.effectiveDays - 生效天數
   * @returns {Promise<Object>} 更新後的規則
   */
  updateNormalRule: async (data) => {
    const response = await apiClient.put('/admin/points/earning-rules/normal', data);
    return response;
  },

  enableNormalRule: async () => {
    const response = await apiClient.post('/admin/points/earning-rules/normal/enable');
    return response;
  },

  disableNormalRule: async () => {
    const response = await apiClient.post('/admin/points/earning-rules/normal/disable');
    return response;
  },

  /**
   * 取得時間區間規則列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁筆數
   * @param {string} params.status - 狀態
   * @param {string} params.startDate - 開始日期
   * @param {string} params.endDate - 結束日期
   * @returns {Promise<Object>} 規則列表
   */
  listTimeRangeRules: async (params = {}) => {
    const response = await apiClient.get('/admin/points/earning-rules/time-range', { params });
    return response;
  },

  /**
   * 取得時間區間規則詳情
   * @param {string} id - 規則 ID
   * @returns {Promise<Object>} 規則詳情
   */
  getTimeRangeRule: async (id) => {
    const response = await apiClient.get(`/admin/points/earning-rules/time-range/${id}`);
    return response;
  },

  /**
   * 建立時間區間規則
   * @param {Object} data - 規則資料
   * @param {string} data.ruleName - 規則名稱
   * @param {string} data.startTime - 開始時間
   * @param {string} data.endTime - 結束時間
   * @param {Object} data.tierConfig - 會員等級回饋率設定
   * @param {string} data.calculationBase - 計算基準
   * @param {string} data.roundingMethod - 四捨五入方式
   * @param {number} data.effectiveDays - 生效天數
   * @param {string} data.status - 狀態
   * @returns {Promise<Object>} 建立的規則
   */
  createTimeRangeRule: async (data) => {
    const response = await apiClient.post('/admin/points/earning-rules/time-range', data);
    return response;
  },

  /**
   * 更新時間區間規則
   * @param {string} id - 規則 ID
   * @param {Object} data - 更新資料
   * @returns {Promise<Object>} 更新後的規則
   */
  updateTimeRangeRule: async (id, data) => {
    const response = await apiClient.put(`/admin/points/earning-rules/time-range/${id}`, data);
    return response;
  },

  /**
   * 刪除時間區間規則
   * @param {string} id - 規則 ID
   * @returns {Promise<void>}
   */
  deleteTimeRangeRule: async (id) => {
    const response = await apiClient.delete(`/admin/points/earning-rules/time-range/${id}`);
    return response;
  },

  /**
   * 啟用時間區間規則
   * @param {string} id - 規則 ID
   * @returns {Promise<Object>} 更新後的規則
   */
  enableTimeRangeRule: async (id) => {
    const response = await apiClient.post(`/admin/points/earning-rules/time-range/${id}/enable`);
    return response;
  },

  /**
   * 停用時間區間規則
   * @param {string} id - 規則 ID
   * @returns {Promise<Object>} 更新後的規則
   */
  disableTimeRangeRule: async (id) => {
    const response = await apiClient.post(`/admin/points/earning-rules/time-range/${id}/disable`);
    return response;
  },

  /**
   * 查詢常態規則變更記錄
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 變更記錄列表
   */
  getNormalRuleLogs: async (params = {}) => {
    const response = await apiClient.get('/admin/points/earning-rules/normal/logs', { params });
    return response;
  },

  /**
   * 查詢時間區間規則變更記錄
   * @param {string} id - 規則 ID
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 變更記錄列表
   */
  getRuleLogs: async (id, params = {}) => {
    const response = await apiClient.get(`/admin/points/earning-rules/time-range/${id}/logs`, { params });
    return response;
  },

  /**
   * 取得當前生效的規則
   * @returns {Promise<Object>} 生效的規則
   */
  getActiveRule: async () => {
    const response = await apiClient.get('/admin/points/earning-rules/active');
    return response;
  }
};
